export const coachDetailsUrls = {
  GET_COACH_QUESTIONS: '/api/coach-questions/answer/{coachId}',
  POST_COACH_ANSWERS: '/api/coach-questions/answer',
  GET_PROFILE: '/api/coach/profile/{coachId}',
  EDIT_PROFILE: '/api/coach/profile',
  UPLOAD_FILE: '/api/file/upload',
  GET_FILE: 'api/file/{fileId}', // removed slash at beginning on purpose
};
